<template lang="pug">
  .form-group.form-check
    .panel.panel-default
      .panel-heading
        .panel-title {{ toSentence(propertyName )}}
      .panel-body
        ObjectInput(
          :schema="property"
          :mappings="mappings"
          :disabled="disabled"
          :metadata="localData"
          @update:data="update")
</template>

<script>
import Base from '../base'
import ObjectInput from '../ObjectInput'

export default {
  extends: Base,
  accepts(property) {
    return property.type === 'object'
  },
  data: () => ({
    propertyValidity: [],
  }),
  components: {
    ObjectInput
  },
  methods: {
    update(value, isValid) {
      const invalidProps = this.propertyValidity.filter((pv) => !pv && typeof pv !== 'undefined')
      this.$emit('update:data', value, invalidProps.length === 0)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/metadataeditor/template/default/Object.vue